import { render, staticRenderFns } from "./typeOfStudy.vue?vue&type=template&id=0ed65b17&scoped=true&lang=pug&"
import script from "./typeOfStudy.vue?vue&type=script&lang=js&"
export * from "./typeOfStudy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed65b17",
  null
  
)

export default component.exports